import "./DropdownItemUI.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React, { ReactNode } from "react";
import Form from "react-bootstrap/Form";

interface IProps {
    text: ReactNode;
    icon: IconProp;
    onChange: Function;
    checked: boolean;
    name: string;
}

export default function DropdownItemCheck(props: IProps) {
    return (
        <div className="dropdownItemSwitch" onClick={() => props.onChange(!props.checked)}>
            <div className="dropdownItemUI">
                <Form.Check
                    aria-label={props.name}
                    id={props.name}
                    onChange={(e) => props.onChange(!props.checked)}
                    name={props.name}
                    checked={props.checked}
                    onClick={(e) => e.stopPropagation()}
                />
                <div className="textDiv">{props.text}</div>
            </div>
        </div>
    );
}
